import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const ImportedOrLocal = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data = [], handleSearch } = useFilter(filterPageName, dependentFilterList?.importedFlagList);

	const responseData = data.map((item) => ({
		id: item?.name,
		categoryId: item?.constant,
		...item
	}));

	return (
		<>
			<FilterName type="IMPORTED_OR_LOCAL" />
			<Checkbox data={responseData} type="IMPORTED_OR_LOCAL" handleSearch={handleSearch} />
		</>
	);
};

export default ImportedOrLocal;
